import { createSelector } from '@reduxjs/toolkit';

import { FeaturePatternTrussSettings, isFeaturePatternTruss } from '@paragon/contract-library';

import { RootState } from '..';
import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

export const getActiveFeaturePatternTrussSettings = createSelector(
  (state: RootState) => state.application.insertingObjectInfo,
  getActiveComponentDesign,
  (insertingObjectInfo, activeComponentDesign) => {
    if (
      insertingObjectInfo &&
      insertingObjectInfo.type === 'componentDesign' &&
      insertingObjectInfo.definitionType === 'FeaturePattern'
    ) {
      return insertingObjectInfo.designSettings as FeaturePatternTrussSettings;
    }
    if (activeComponentDesign && isFeaturePatternTruss(activeComponentDesign.component)) {
      return activeComponentDesign.component.settings;
    }
    return null;
  },
);

export const getActiveInferredFeaturePatternTrussSettings = createSelector(
  getActiveComponentDesign,
  (activeComponentDesign) => {
    if (activeComponentDesign && isFeaturePatternTruss(activeComponentDesign.component)) {
      return activeComponentDesign.component.inferredSettings;
    }

    return null;
  },
);
